/**
 * Utilitários para manipulação de mensagens
 */

/**
 * Formata o horário da mensagem para exibição
 */
export const formatMessageTime = (sentAt: string): string => {
  try {
    const date = new Date(sentAt)
    const now = new Date()
    
    // Se for hoje, mostrar apenas horário
    if (date.toDateString() === now.toDateString()) {
      return date.toLocaleTimeString('pt-BR', { 
        hour: '2-digit', 
        minute: '2-digit' 
      })
    }
    
    // Se for ontem
    const yesterday = new Date(now)
    yesterday.setDate(yesterday.getDate() - 1)
    if (date.toDateString() === yesterday.toDateString()) {
      return `Ontem ${date.toLocaleTimeString('pt-BR', { 
        hour: '2-digit', 
        minute: '2-digit' 
      })}`
    }
    
    // Se for esta semana
    const weekAgo = new Date(now)
    weekAgo.setDate(weekAgo.getDate() - 7)
    if (date > weekAgo) {
      const dayName = date.toLocaleDateString('pt-BR', { weekday: 'short' })
      return `${dayName} ${date.toLocaleTimeString('pt-BR', { 
        hour: '2-digit', 
        minute: '2-digit' 
      })}`
    }
    
    // Mais antigo, mostrar data completa
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    })
  } catch (error) {
    console.error('Erro ao formatar data da mensagem:', error)
    return 'Data inválida'
  }
}

/**
 * Formata o tipo de mensagem para exibição
 */
export const formatMessageType = (msgType: string): string => {
  const typeMap: Record<string, string> = {
    'conversation': 'Texto',
    'extendedTextMessage': 'Texto',
    'imageMessage': 'Imagem',
    'videoMessage': 'Vídeo',
    'audioMessage': 'Áudio',
    'documentMessage': 'Documento',
    'stickerMessage': 'Sticker',
    'locationMessage': 'Localização',
    'contactMessage': 'Contato',
    'reactionMessage': 'Reação',
    'protocolMessage': 'Sistema'
  }
  
  return typeMap[msgType] || msgType
}

/**
 * Verifica se a mensagem contém mídia
 */
export const hasMedia = (message: any): boolean => {
  const mediaTypes = [
    'imageMessage',
    'videoMessage', 
    'audioMessage',
    'documentMessage',
    'stickerMessage'
  ]
  
  return mediaTypes.some(type => message.msg_type === type)
}

/**
 * Gera preview do conteúdo da mensagem
 */
export const getMessagePreview = (message: any): string => {
  if (message.text_content) {
    return message.text_content.length > 50 
      ? message.text_content.substring(0, 50) + '...'
      : message.text_content
  }
  
  if (message.media_kind) {
    return `📎 ${formatMessageType(message.msg_type)}`
  }
  
  return '[Mensagem sem conteúdo]'
}